import { render, staticRenderFns } from "./BotCarouselMessage.vue?vue&type=template&id=3e439657&"
import script from "./BotCarouselMessage.ts?vue&type=script&lang=ts&"
export * from "./BotCarouselMessage.ts?vue&type=script&lang=ts&"
import style0 from "./BotCarouselMessage.scss?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports